import { defineComponent as L, watchEffect as H, computed as g, ref as T, h as t, mergeProps as N } from "vue";
import { useRtl as O } from "./ghl-ui.es875.js";
import F from "./ghl-ui.es876.js";
import { warnOnce as M } from "./ghl-ui.es877.js";
import j from "./ghl-ui.es878.js";
import v from "./ghl-ui.es879.js";
import { getMargin as k } from "./ghl-ui.es880.js";
import { createKey as l } from "./ghl-ui.es404.js";
import { useThemeClass as V } from "./ghl-ui.es881.js";
import W from "./ghl-ui.es882.js";
import D from "./ghl-ui.es883.js";
import { resolveSlot as K, resolveWrappedSlot as q } from "./ghl-ui.es884.js";
import G from "./ghl-ui.es885.js";
import J from "./ghl-ui.es886.js";
import Q from "./ghl-ui.es887.js";
import U from "./ghl-ui.es888.js";
import X from "./ghl-ui.es889.js";
import Y from "./ghl-ui.es890.js";
const Z = Object.assign(Object.assign({}, v.props), {
  title: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  type: {
    type: String,
    default: "default"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  onClose: Function,
  onAfterLeave: Function,
  /** @deprecated */
  onAfterHide: Function
}), Re = L({
  name: "Alert",
  inheritAttrs: !1,
  props: Z,
  setup(r) {
    process.env.NODE_ENV !== "production" && H(() => {
      r.onAfterHide !== void 0 && M("alert", "`on-after-hide` is deprecated, please use `on-after-leave` instead.");
    });
    const {
      mergedClsPrefixRef: e,
      mergedBorderedRef: i,
      inlineThemeDisabled: d,
      mergedRtlRef: f
    } = j(r), a = v("Alert", "-alert", F, G, r, e), b = O("Alert", f, e), m = g(() => {
      const {
        common: {
          cubicBezierEaseInOut: s
        },
        self: o
      } = a.value, {
        fontSize: C,
        borderRadius: R,
        titleFontWeight: A,
        lineHeight: I,
        iconSize: y,
        iconMargin: h,
        iconMarginRtl: $,
        closeIconSize: _,
        closeBorderRadius: x,
        closeSize: z,
        closeMargin: B,
        closeMarginRtl: P,
        padding: w
      } = o, {
        type: n
      } = r, {
        left: E,
        right: S
      } = k(h);
      return {
        "--n-bezier": s,
        "--n-color": o[l("color", n)],
        "--n-close-icon-size": _,
        "--n-close-border-radius": x,
        "--n-close-color-hover": o[l("closeColorHover", n)],
        "--n-close-color-pressed": o[l("closeColorPressed", n)],
        "--n-close-icon-color": o[l("closeIconColor", n)],
        "--n-close-icon-color-hover": o[l("closeIconColorHover", n)],
        "--n-close-icon-color-pressed": o[l("closeIconColorPressed", n)],
        "--n-icon-color": o[l("iconColor", n)],
        "--n-border": o[l("border", n)],
        "--n-title-text-color": o[l("titleTextColor", n)],
        "--n-content-text-color": o[l("contentTextColor", n)],
        "--n-line-height": I,
        "--n-border-radius": R,
        "--n-font-size": C,
        "--n-title-font-weight": A,
        "--n-icon-size": y,
        "--n-icon-margin": h,
        "--n-icon-margin-rtl": $,
        "--n-close-size": z,
        "--n-close-margin": B,
        "--n-close-margin-rtl": P,
        "--n-padding": w,
        "--n-icon-margin-left": E,
        "--n-icon-margin-right": S
      };
    }), c = d ? V("alert", g(() => r.type[0]), m, r) : void 0, u = T(!0), p = () => {
      const {
        onAfterLeave: s,
        onAfterHide: o
        // deprecated
      } = r;
      s && s(), o && o();
    };
    return {
      rtlEnabled: b,
      mergedClsPrefix: e,
      mergedBordered: i,
      visible: u,
      handleCloseClick: () => {
        var s;
        Promise.resolve((s = r.onClose) === null || s === void 0 ? void 0 : s.call(r)).then((o) => {
          o !== !1 && (u.value = !1);
        });
      },
      handleAfterLeave: () => {
        p();
      },
      mergedTheme: a,
      cssVars: d ? void 0 : m,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender
    };
  },
  render() {
    var r;
    return (r = this.onRender) === null || r === void 0 || r.call(this), t(W, {
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => {
        const {
          mergedClsPrefix: e,
          $slots: i
        } = this, d = {
          class: [
            `${e}-alert`,
            this.themeClass,
            this.closable && `${e}-alert--closable`,
            this.showIcon && `${e}-alert--show-icon`,
            // fix: https://github.com/tusen-ai/naive-ui/issues/4588
            !this.title && this.closable && `${e}-alert--right-adjust`,
            this.rtlEnabled && `${e}-alert--rtl`
          ],
          style: this.cssVars,
          role: "alert"
        };
        return this.visible ? (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          t("div", Object.assign({}, N(this.$attrs, d)), this.closable && t(D, {
            clsPrefix: e,
            class: `${e}-alert__close`,
            onClick: this.handleCloseClick
          }), this.bordered && t("div", {
            class: `${e}-alert__border`
          }), this.showIcon && t("div", {
            class: `${e}-alert__icon`,
            "aria-hidden": "true"
          }, K(i.icon, () => [t(J, {
            clsPrefix: e
          }, {
            default: () => {
              switch (this.type) {
                case "success":
                  return t(Y, null);
                case "info":
                  return t(X, null);
                case "warning":
                  return t(U, null);
                case "error":
                  return t(Q, null);
                default:
                  return null;
              }
            }
          })])), t("div", {
            class: [`${e}-alert-body`, this.mergedBordered && `${e}-alert-body--bordered`]
          }, q(i.header, (f) => {
            const a = f || this.title;
            return a ? t("div", {
              class: `${e}-alert-body__title`
            }, a) : null;
          }), i.default && t("div", {
            class: `${e}-alert-body__content`
          }, i)))
        ) : null;
      }
    });
  }
});
export {
  Z as alertProps,
  Re as default
};
